import React, { useState, useCallback } from 'react';
import styles from './ChatLink.module.scss';

interface ChatLinkProps {
  label: string;
  url: string;
}

export const ChatLink: React.FC<ChatLinkProps> = ({ label, url }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      navigator.clipboard.writeText(url).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      });
    },
    [url],
  );

  return (
    <span className={styles.linkRow}>
      <a href={url} target="_blank" rel="noopener noreferrer" className={styles.linkText}>
        {label}
      </a>
      <button
        type="button"
        className={`${styles.copyPill} ${copied ? styles.copied : ''}`}
        onClick={handleCopy}
        title={copied ? 'Copied!' : 'Copy URL'}
        aria-label="Copy URL"
      >
        {copied ? (
          <>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
              <path
                d="M20 6L9 17l-5-5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>Copied</span>
          </>
        ) : (
          <>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
              <rect
                x="9"
                y="9"
                width="13"
                height="13"
                rx="2"
                stroke="currentColor"
                strokeWidth="2"
              />
              <path
                d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"
                stroke="currentColor"
                strokeWidth="2"
              />
            </svg>
            <span>Copy URL</span>
          </>
        )}
      </button>
    </span>
  );
};
